import React from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap'; // Added missing imports


const AddReleaseNoteModal = ({ show, onHide, noteData, setNoteData, onSave }) => (
    <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
            <Modal.Title className="fw-bold">
                {noteData.id ? "Edit Release Note" : "Create Product Release Note"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Version Number</Form.Label>
                            <Form.Control 
                                type="text" placeholder="e.g. v2.5" 
                                value={noteData.version}
                                onChange={(e) => setNoteData({...noteData, version: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Category</Form.Label>
                            <Form.Select 
                                value={noteData.category}
                                onChange={(e) => setNoteData({...noteData, category: e.target.value})}
                            >
                                <option>New</option>
                                <option>Improvements</option>
                                <option>Changes</option>
                                <option>Bug Fixes</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control 
                        type="text" placeholder="Summary of the update"
                        value={noteData.title}
                        onChange={(e) => setNoteData({...noteData, title: e.target.value})}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Description (Markdown supported)</Form.Label>
                    <Form.Control 
                        as="textarea" rows={6} 
                        placeholder="Detail the technical impact..."
                        value={noteData.description}
                        onChange={(e) => setNoteData({...noteData, description: e.target.value})}
                    />
                </Form.Group>
                <Form.Check 
                    type="switch" label="Staging Only" 
                    checked={noteData.is_staging_only}
                    onChange={(e) => setNoteData({...noteData, is_staging_only: e.target.checked})}
                />
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>Cancel</Button>
            <Button variant="primary" onClick={onSave}>Publish Note</Button>
        </Modal.Footer>
    </Modal>
);
export default AddReleaseNoteModal;